/**
 * Data de previsão default de um modelo do Comparador Clássico ao abrir (#1822, item 5.3).
 *
 * Regra da Bruna (reunião 15/07): o modelo **confrontante** abre na data mais
 * recente disponível; o modelo **base** abre na **penúltima** (para comparar a
 * rodada anterior com a mais recente). Se o base só tem 1 data, cai nela.
 *
 * `availableDates` é assumido em ordem crescente (mesmo contrato do efeito
 * anterior, que tratava o último elemento como a mais recente).
 */
export default function defaultModelDate(
  availableDates: Date[],
  isBaseModel: boolean,
): Date | undefined {
  if (availableDates.length === 0) return undefined;

  const latest = availableDates[availableDates.length - 1];
  if (!isBaseModel) return latest;

  return availableDates[availableDates.length - 2] ?? latest;
}
